/**
 * @chordbaker/design - Icons
 *
 * Shared icon SVG data for ChordBaker applications.
 * These are platform-agnostic data definitions. Each platform
 * wraps them with its own SVG rendering (react-native-svg or native HTML SVG).
 */
// ---------------------------------------------------------------------------
// Icon Definitions
// ---------------------------------------------------------------------------
export const cloudIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 24,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z' },
    ],
};
export const clipboardIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 24,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'rect', x: 8, y: 2, width: 8, height: 4, rx: 1 },
        { type: 'path', d: 'M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2' },
        { type: 'path', d: 'M8 11h8M8 15h5' },
    ],
};
export const closeIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 16,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M6 18L18 6M6 6l12 12' },
    ],
};
export const degreesIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 24,
    fill: 'none',
    elements: [
        { type: 'circle', cx: 12, cy: 12, r: 10, stroke: 'currentColor', strokeWidth: 2, fill: 'none' },
        { type: 'text', x: 12, y: 16, fontSize: 10, fontWeight: 'bold', textAnchor: 'middle', content: 'I', fill: 'currentColor' },
    ],
};
export const downloadIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 24,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' },
        { type: 'polyline', points: '7 10 12 15 17 10' },
        { type: 'line', x1: 12, y1: 15, x2: 12, y2: 3 },
    ],
};
export const duplicateIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 16,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75' },
    ],
};
export const editIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 24,
    fill: 'none',
    elements: [
        { type: 'path', d: 'M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
        { type: 'path', d: 'M18.5 2.50001C18.8978 2.10219 19.4374 1.87869 20 1.87869C20.5626 1.87869 21.1022 2.10219 21.5 2.50001C21.8978 2.89784 22.1213 3.4374 22.1213 4.00001C22.1213 4.56262 21.8978 5.10219 21.5 5.50001L12 15L8 16L9 12L18.5 2.50001Z', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
    ],
};
export const feedbackIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 24,
    fill: 'none',
    elements: [
        { type: 'path', d: 'M21 11.5C21 16.75 16.97 21 12 21C10.73 21 9.52 20.75 8.42 20.3L3 21L4.7 15.58C3.64 14.24 3 12.66 3 11C3 6.03 7.03 2 12 2C16.97 2 21 6.25 21 11.5Z', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' },
        { type: 'path', d: 'M8 11H8.01M12 11H12.01M16 11H16.01', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
    ],
};
export const guitarIcon = {
    viewBox: '0 0 29.711 29.711',
    defaultSize: 24,
    fill: 'currentColor',
    elements: [
        { type: 'path', d: 'M28.71,4.273l0.668-0.668c0.443-0.443,0.443-1.164,0-1.607l-1.664-1.664C27.501,0.121,27.212,0,26.91,0 s-0.591,0.12-0.804,0.333l-0.669,0.668l-0.653-0.653c-0.271-0.271-0.711-0.271-0.982,0c-0.271,0.271-0.271,0.71,0,0.981 l0.654,0.653L24.129,2.31l-0.653-0.654c-0.271-0.271-0.711-0.271-0.981,0c-0.271,0.271-0.271,0.711,0,0.982l0.653,0.653 L22.82,3.619l-0.653-0.653c-0.271-0.271-0.71-0.271-0.981,0c-0.271,0.271-0.271,0.71,0,0.981L21.839,4.6l-4.939,4.94 c-2.369-1.258-5.109-1.105-6.812,0.597c-0.315,0.315-0.577,0.667-0.788,1.046c-0.458,0.828-1.325,1.35-2.273,1.367 c-1.878,0.035-3.653,0.703-4.986,2.035c-3.068,3.068-2.625,8.484,0.988,12.097s9.03,4.056,12.098,0.988 c1.332-1.332,2.001-3.107,2.035-4.986c0.018-0.946,0.541-1.816,1.367-2.273c0.379-0.21,0.73-0.472,1.047-0.787 c1.701-1.702,1.854-4.444,0.596-6.812l4.94-4.939l0.653,0.654c0.137,0.135,0.313,0.203,0.491,0.203s0.354-0.068,0.491-0.203 c0.271-0.271,0.271-0.711,0-0.982l-0.654-0.653l0.326-0.327l0.654,0.654c0.137,0.135,0.314,0.203,0.491,0.203 c0.178,0,0.354-0.068,0.491-0.203c0.271-0.271,0.271-0.711,0-0.982l-0.654-0.653l0.327-0.328l0.655,0.655 c0.135,0.135,0.313,0.203,0.49,0.203s0.354-0.068,0.49-0.203c0.271-0.271,0.271-0.711,0-0.982L28.71,4.273z M15.787,18.504 c-1.265,1.265-3.315,1.265-4.58,0s-1.265-3.315,0-4.58s3.316-1.265,4.58,0C17.052,15.189,17.053,17.239,15.787,18.504z' },
    ],
};
export const helpIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 24,
    fill: 'none',
    elements: [
        { type: 'circle', cx: 12, cy: 12, r: 10, stroke: 'currentColor', strokeWidth: 1.5 },
        { type: 'path', d: 'M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' },
        { type: 'path', d: 'M12 17h.01', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round' },
    ],
};
export const infoIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 24,
    fill: 'none',
    elements: [
        { type: 'circle', cx: 12, cy: 12, r: 10, stroke: 'currentColor', strokeWidth: 1.5 },
        { type: 'path', d: 'M12 16v-4', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round' },
        { type: 'path', d: 'M12 8h.01', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round' },
    ],
};
export const languageIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 24,
    fill: 'none',
    elements: [
        { type: 'circle', cx: 12, cy: 12, r: 10, stroke: 'currentColor', strokeWidth: 1.5 },
        { type: 'path', d: 'M2 12h20', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round' },
        { type: 'path', d: 'M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' },
    ],
};
export const loadSongsIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 16,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v8.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z' },
    ],
};
export const lyricsIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 12,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' },
        { type: 'path', d: 'M14 2v6h6' },
        { type: 'path', d: 'M8 13h8' },
        { type: 'path', d: 'M8 17h8' },
    ],
};
export const lyricsToggleIcon = {
    viewBox: '0 0 97 105',
    defaultSize: 12,
    fill: 'currentColor',
    elements: [
        { type: 'path', d: 'M52.959 88.623C40.7129 99.4368 29.7201 104.844 19.9805 104.844C14.2513 104.844 9.48893 102.982 5.69336 99.2578C1.89779 95.4622 0 90.7357 0 85.0781C0 77.4154 3.29427 70.5404 9.88281 64.4531C16.4714 58.2943 30.8301 50.1302 52.959 39.9609V29.8633C52.959 22.2721 52.5293 17.5098 51.6699 15.5762C50.8822 13.571 49.3424 11.8522 47.0508 10.4199C44.7591 8.91602 42.181 8.16406 39.3164 8.16406C34.6615 8.16406 30.8301 9.20247 27.8223 11.2793C25.9603 12.5684 25.0293 14.0723 25.0293 15.791C25.0293 17.2949 26.0319 19.1569 28.0371 21.377C30.7585 24.4564 32.1191 27.4284 32.1191 30.293C32.1191 33.8021 30.7943 36.8099 28.1445 39.3164C25.5664 41.7513 22.1647 42.9688 17.9395 42.9688C13.4277 42.9688 9.63216 41.6081 6.55273 38.8867C3.54492 36.1654 2.04102 32.9785 2.04102 29.3262C2.04102 24.1699 4.08203 19.2643 8.16406 14.6094C12.2461 9.88281 17.9395 6.26628 25.2441 3.75977C32.5488 1.25326 40.14 0 48.0176 0C57.5423 0 65.0618 2.04102 70.5762 6.12305C76.1621 10.1335 79.7786 14.502 81.4258 19.2285C82.4284 22.2363 82.9297 29.1471 82.9297 39.9609V78.9551C82.9297 83.5384 83.1087 86.4388 83.4668 87.6562C83.8249 88.8021 84.362 89.6615 85.0781 90.2344C85.7943 90.8073 86.6178 91.0938 87.5488 91.0938C89.4108 91.0938 91.3086 89.7689 93.2422 87.1191L96.4648 89.6973C92.8841 94.9967 89.1602 98.8639 85.293 101.299C81.4974 103.662 77.1647 104.844 72.2949 104.844C66.5658 104.844 62.0898 103.519 58.8672 100.869C55.6445 98.1478 53.6751 94.0658 52.959 88.623ZM52.959 80.7812V47.1582C44.2936 52.2428 37.8483 57.6855 33.623 63.4863C30.8301 67.3535 29.4336 71.2565 29.4336 75.1953C29.4336 78.4896 30.6152 81.39 32.9785 83.8965C34.7689 85.8301 37.2754 86.7969 40.498 86.7969C44.0788 86.7969 48.2324 84.7917 52.959 80.7812Z', fill: 'currentColor' },
    ],
};
export const playIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 16,
    fill: 'currentColor',
    elements: [
        { type: 'path', d: 'M8 5v14l11-7z' },
    ],
};
export const pauseIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 16,
    fill: 'currentColor',
    elements: [
        { type: 'path', d: 'M6 5h4v14H6zM14 5h4v14h-4z' },
    ],
};
/** Back to the start (⏮): a bar and a left-pointing triangle. */
export const skipToStartIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 16,
    fill: 'currentColor',
    elements: [
        { type: 'path', d: 'M6 6h2v12H6zm3.5 6l8.5 6V6z' },
    ],
};
/**
 * Performance View: a handheld stage microphone (ball head, collar, tapered
 * handle). Deliberately not a play triangle, so it can't be mistaken for song
 * playback's filled ▶, and the tapered handle keeps it apart from `searchIcon`.
 */
export const performIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 20,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M16.23 14.25A5 5 0 1 0 9.75 7.77Z' },
        { type: 'path', d: 'M14.82 12.85L6.76 18.93a1.2 1.2 0 0 1-1.69-1.69L11.15 9.18' },
    ],
};
export const menuIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 24,
    fill: 'currentColor',
    elements: [
        { type: 'path', d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' },
    ],
};
export const minusIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 16,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M5 12h14' },
    ],
};
/**
 * Two columns of three dots: the grip on each row of the reorder sheet, the
 * part you drag (every platform).
 */
export const dragHandleIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 20,
    fill: 'none',
    elements: [
        { type: 'circle', cx: 9, cy: 5, r: 2, fill: 'currentColor' },
        { type: 'circle', cx: 15, cy: 5, r: 2, fill: 'currentColor' },
        { type: 'circle', cx: 9, cy: 12, r: 2, fill: 'currentColor' },
        { type: 'circle', cx: 15, cy: 12, r: 2, fill: 'currentColor' },
        { type: 'circle', cx: 9, cy: 19, r: 2, fill: 'currentColor' },
        { type: 'circle', cx: 15, cy: 19, r: 2, fill: 'currentColor' },
    ],
};
/** An up and a down arrow side by side: "Reorder chart", which opens the reorder sheet. */
export const reorderIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 20,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M3 9l4-4 4 4M7 5v14' },
        { type: 'path', d: 'M21 15l-4 4-4-4M17 19V5' },
    ],
};
export const moreOptionsIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 24,
    fill: 'none',
    elements: [
        { type: 'circle', cx: 12, cy: 5, r: 2, fill: 'currentColor' },
        { type: 'circle', cx: 12, cy: 12, r: 2, fill: 'currentColor' },
        { type: 'circle', cx: 12, cy: 19, r: 2, fill: 'currentColor' },
    ],
};
export const musicKeyIcon = {
    viewBox: '0 0 512 512',
    defaultSize: 24,
    fill: 'currentColor',
    elements: [
        { type: 'path', d: 'M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24l0-40 40 0c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z' },
    ],
};
export const musicNoteIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 12,
    fill: 'currentColor',
    elements: [
        { type: 'path', d: 'M12 3v10.5c-.6-.3-1.3-.5-2-.5-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4V9l6-2V5l-8 2V3z' },
    ],
};
export const newSongIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 16,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M12 5v14m-7-7h14' },
    ],
};
export const pdfIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 24,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' },
        { type: 'path', d: 'M14 2v6h6' },
        { type: 'line', x1: 8, y1: 13, x2: 16, y2: 13 },
        { type: 'line', x1: 8, y1: 16, x2: 14, y2: 16 },
        { type: 'line', x1: 8, y1: 19, x2: 12, y2: 19 },
    ],
};
export const pencilIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 12,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z' },
    ],
};
export const pianoIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 12,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'rect', x: 3, y: 4, width: 18, height: 16, rx: 1 },
        { type: 'line', x1: 9, y1: 4, x2: 9, y2: 20 },
        { type: 'line', x1: 15, y1: 4, x2: 15, y2: 20 },
        { type: 'rect', x: 6, y: 4, width: 3, height: 9, fill: 'currentColor' },
        { type: 'rect', x: 12, y: 4, width: 3, height: 9, fill: 'currentColor' },
    ],
};
export const plusIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 16,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M12 5v14M5 12h14' },
    ],
};
/** Add a slot before (to the left of) the current one: plus, then the slot. */
export const insertBeforeIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 20,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.9,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'rect', x: 13, y: 5, width: 8, height: 14, rx: 2 },
        { type: 'path', d: 'M6 9v6M3 12h6' },
    ],
};
/** Add a slot after (to the right of) the current one: the slot, then plus. */
export const insertAfterIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 20,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.9,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'rect', x: 3, y: 5, width: 8, height: 14, rx: 2 },
        { type: 'path', d: 'M18 9v6M15 12h6' },
    ],
};
/** Metronome: the beats button in the slot action pill. */
export const beatsIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 20,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M8 3h8l3 18H5z' },
        { type: 'path', d: 'M12 17l5-10' },
        { type: 'path', d: 'M8 17h8' },
    ],
};
/** Three beat dots: the Beats toggle's glyph in the Display menu. */
export const beatsToggleIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 16,
    fill: 'currentColor',
    elements: [
        { type: 'circle', cx: 5, cy: 12, r: 2.5 },
        { type: 'circle', cx: 12, cy: 12, r: 2.5 },
        { type: 'circle', cx: 19, cy: 12, r: 2.5 },
    ],
};
export const freePlanIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 20,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M20 12v10H4V12' },
        { type: 'path', d: 'M2 7h20v5H2z' },
        { type: 'path', d: 'M12 22V7' },
        { type: 'path', d: 'M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z' },
        { type: 'path', d: 'M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z' },
    ],
};
export const proPlanIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 20,
    fill: 'currentColor',
    stroke: 'currentColor',
    strokeWidth: 0.5,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z' },
    ],
};
export const prohibitedIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 24,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'circle', cx: 12, cy: 12, r: 10 },
        { type: 'path', d: 'm4.9 4.9 14.2 14.2' },
    ],
};
export const redoIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 24,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M21 7v6h-6' },
        { type: 'path', d: 'M3 17a9 9 0 019-9 9 9 0 016 2.3L21 13' },
    ],
};
export const savingIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 16,
    fill: 'none',
    elements: [
        { type: 'path', d: 'M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z', stroke: 'currentColor', strokeWidth: 1.5 },
        { type: 'path', d: 'M17 21v-8H7v8', stroke: 'currentColor', strokeWidth: 1.5 },
        { type: 'path', d: 'M7 3v5h8', stroke: 'currentColor', strokeWidth: 1.5 },
        { type: 'circle', cx: 18, cy: 6, r: 2, fill: 'currentColor', opacity: 0.8 },
    ],
};
export const searchIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 16,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'm21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z' },
    ],
};
export const shareIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 24,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'circle', cx: 18, cy: 5, r: 3 },
        { type: 'circle', cx: 6, cy: 12, r: 3 },
        { type: 'circle', cx: 18, cy: 19, r: 3 },
        { type: 'line', x1: 8.59, y1: 13.51, x2: 15.42, y2: 17.49 },
        { type: 'line', x1: 15.41, y1: 6.51, x2: 8.59, y2: 10.49 },
    ],
};
export const speakerIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 12,
    fill: 'currentColor',
    elements: [
        { type: 'path', d: 'M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z' },
    ],
};
/** Speaker with a line through it (sound off) — the off state of `speakerIcon`, same family (Material volume_off). */
export const speakerOffIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 12,
    fill: 'currentColor',
    elements: [
        { type: 'path', d: 'M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z' },
    ],
};
/** Moon icon variant for dark mode toggle (shown when in dark mode). */
export const themeToggleMoonIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 20,
    fill: 'none',
    elements: [
        { type: 'path', d: 'M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.752-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' },
    ],
};
/** Sun icon variant for dark mode toggle (shown when in light mode). */
export const themeToggleSunIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 20,
    fill: 'none',
    elements: [
        { type: 'path', d: 'M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' },
    ],
};
export const trashIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 16,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'm14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12.56 0c1.153 0 2.24.03 3.22.077m7.124 0c-.097.015-.195.022-.293.022m-7.124 0a24.261 24.261 0 0 0-3.22-.077m3.22.077L5.88 16.251m12.743-10.472a48.967 48.967 0 0 1-5.262 0' },
    ],
};
export const chevronLeftIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 24,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M15 18l-6-6 6-6', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
    ],
};
export const returnIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 16,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M19 20L9 12 19 4V20' },
        { type: 'path', d: 'M5 19V5' },
    ],
};
export const undoIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 24,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M3 7v6h6' },
        { type: 'path', d: 'M21 17a9 9 0 00-9-9 9 9 0 00-6 2.3L3 13' },
    ],
};
export const uploadIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 24,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' },
        { type: 'polyline', points: '17 8 12 3 7 8' },
        { type: 'line', x1: 12, y1: 3, x2: 12, y2: 15 },
    ],
};
/**
 * ChordBaker Buffet logo.
 *
 * NOTE: The original SVG uses a group transform (translate + scale with Y-flip).
 * The paths below are defined in the transformed coordinate space (0–6000, Y-up).
 * Platform renderers must wrap the paths in a `<g>` with
 *   transform="translate(0,600) scale(0.1,-0.1)"
 * inside a viewBox of "0 0 600 600".
 */
export const buffetLogoIcon = {
    viewBox: '0 0 600 600',
    defaultSize: 24,
    fill: 'currentColor',
    elements: [
        { type: 'path', d: 'M4758 4935 c-156 -34 -253 -118 -390 -340 -45 -71 -147 -236 -228 -365 -81 -129 -171 -275 -200 -325 -130 -220 -312 -494 -427 -642 -89 -116 -176 -183 -282 -218 -47 -15 -69 -16 -160 -9 -226 19 -350 5 -555 -63 -233 -77 -453 -210 -612 -368 -82 -82 -108 -115 -142 -182 -24 -49 -43 -104 -47 -137 -8 -62 1 -147 18 -170 15 -20 187 -41 198 -25 5 8 12 8 27 0 13 -7 119 -12 289 -13 l268 -3 110 43 c308 120 496 258 633 465 43 65 47 68 50 43 2 -15 -10 -55 -27 -93 -84 -178 -227 -311 -447 -415 l-69 -33 153 -3 c128 -2 159 0 190 15 20 9 82 62 137 117 132 132 177 210 251 431 80 242 140 355 333 615 70 96 148 206 280 400 230 338 222 329 275 316 14 -3 58 -52 112 -123 168 -223 396 -425 480 -425 83 0 84 48 3 162 -122 171 -159 270 -159 433 0 178 21 224 196 420 80 89 131 179 140 250 13 94 -49 198 -143 238 -52 22 -165 24 -255 4z' },
        { type: 'path', d: 'M1770 2693 c-494 -16 -883 -128 -915 -263 -13 -56 61 -126 191 -180 88 -36 312 -93 439 -110 50 -7 104 -15 121 -17 l30 -5 -4 79 c-7 146 53 299 162 413 70 74 83 91 65 88 -8 -1 -48 -3 -89 -5z' },
        { type: 'path', d: 'M3585 2656 c-79 -246 -143 -363 -272 -493 -29 -30 -53 -55 -53 -58 0 -4 39 0 170 21 52 9 115 18 140 20 65 7 272 60 360 91 90 33 185 85 217 119 99 107 -51 213 -402 283 -144 28 -156 30 -160 17z' },
        { type: 'path', d: 'M864 2234 c13 -70 86 -266 137 -369 80 -162 204 -314 354 -434 83 -66 266 -173 349 -203 46 -17 61 -28 71 -52 29 -69 96 -104 273 -143 106 -23 144 -26 395 -30 290 -5 395 2 564 37 146 30 243 86 243 140 0 11 24 29 68 50 107 54 231 129 307 185 80 60 232 214 292 295 98 132 189 324 232 488 l19 72 -32 -19 c-105 -65 -229 -112 -403 -155 -213 -52 -433 -89 -593 -101 -41 -3 -140 -10 -220 -16 -186 -14 -680 -15 -835 -1 -66 6 -163 14 -215 17 -52 4 -167 18 -255 32 -88 14 -183 29 -210 33 -168 26 -432 120 -509 182 l-39 31 7 -39z' },
    ],
};
/**
 * Johan Sebastian chatbot icon (Bach portrait).
 *
 * NOTE: The original SVG uses a group transform (translate + scale with Y-flip).
 * The paths below are defined in the transformed coordinate space (0–6000/5250, Y-up).
 * Platform renderers must wrap the paths in a `<g>` with
 *   transform="translate(0,525) scale(0.1,-0.1)"
 * inside a viewBox of "0 0 600 525".
 */
export const johanIcon = {
    viewBox: '0 0 600 525',
    defaultSize: 24,
    fill: 'currentColor',
    elements: [
        { type: 'path', d: 'M3205 5060 c-107 -22 -212 -76 -291 -152 l-41 -40 -54 41 c-30 23 -88 56 -129 73 -73 32 -80 33 -215 33 -155 0 -211 -13 -348 -82 -111 -55 -232 -192 -272 -310 -12 -36 -13 -37 -101 -54 -161 -33 -286 -113 -367 -237 -99 -150 -137 -321 -106 -473 l11 -55 -74 -74 c-80 -81 -97 -108 -134 -214 -47 -134 -23 -324 51 -422 l26 -34 -42 -52 c-52 -66 -92 -151 -113 -245 -20 -89 -20 -124 -1 -221 28 -137 100 -255 203 -332 l33 -25 -15 -60 c-9 -32 -16 -95 -16 -138 0 -151 52 -279 155 -382 71 -71 156 -118 261 -145 88 -23 137 -25 217 -9 l57 12 60 -64 c69 -74 74 -99 39 -202 -41 -124 -106 -222 -238 -363 -186 -199 -156 -295 129 -409 151 -60 282 -64 361 -9 79 54 133 219 127 384 -5 110 -13 129 -93 220 -57 63 -94 128 -95 163 0 15 11 11 73 -22 301 -163 669 -140 1018 65 222 130 434 356 512 547 9 20 20 37 24 37 4 0 18 -16 30 -35 21 -32 22 -36 8 -76 -20 -55 -87 -176 -125 -225 -105 -133 -312 -306 -517 -433 -125 -77 -201 -144 -256 -229 -69 -105 -91 -166 -92 -247 0 -113 48 -171 163 -196 109 -23 401 11 657 77 196 50 484 160 628 238 23 12 83 44 132 71 167 89 235 148 255 220 28 99 -10 161 -161 265 -145 98 -240 173 -287 224 -24 26 -42 49 -40 52 3 2 31 -5 64 -16 284 -99 633 25 763 269 57 109 81 248 61 351 -24 118 -24 117 3 135 35 23 104 116 132 178 27 59 55 186 55 247 0 151 -87 345 -196 438 l-37 32 31 62 c150 299 12 669 -289 778 l-34 12 0 122 c0 135 -11 179 -74 301 -42 82 -148 192 -234 244 -125 74 -295 110 -427 91 -88 -13 -83 -14 -104 23 -10 17 -53 66 -95 107 -130 127 -273 181 -475 179 -61 -1 -129 -5 -151 -9z m-205 -926 c212 -66 370 -186 487 -367 144 -221 182 -441 203 -1152 10 -350 21 -483 47 -580 23 -84 20 -115 -23 -208 -153 -329 -484 -590 -845 -663 -100 -20 -300 -15 -394 11 -216 58 -448 244 -569 454 -145 254 -169 523 -90 1005 14 83 30 212 36 286 9 124 12 137 36 163 72 77 201 99 297 52 57 -28 87 -31 105 -11 56 69 -136 166 -271 137 -29 -6 -77 -26 -107 -43 l-55 -31 6 119 c16 317 169 585 427 743 145 89 283 122 485 116 116 -3 154 -8 225 -31z' },
        { type: 'path', d: 'M2863 3275 c-106 -29 -163 -70 -163 -114 0 -50 30 -55 110 -17 58 28 74 31 160 31 105 0 144 -14 228 -83 37 -31 47 -34 70 -26 70 25 8 115 -124 180 -59 30 -85 36 -150 40 -51 3 -97 -1 -131 -11z' },
        { type: 'path', d: 'M2060 3009 c-97 -39 -115 -170 -31 -226 119 -81 258 69 169 183 -21 26 -75 55 -100 53 -7 0 -24 -5 -38 -10z' },
        { type: 'path', d: 'M2924 3006 c-95 -42 -108 -173 -22 -226 122 -74 254 73 166 185 -21 27 -74 55 -100 55 -7 -1 -27 -7 -44 -14z' },
        { type: 'path', d: 'M2338 2943 c-8 -10 -18 -27 -21 -38 -3 -11 -21 -76 -40 -145 -19 -69 -51 -181 -71 -249 -29 -100 -34 -130 -27 -157 34 -122 171 -170 300 -104 32 16 81 34 107 41 27 7 55 16 62 22 17 14 15 41 -6 60 -16 15 -24 15 -80 2 -35 -8 -84 -26 -110 -40 -100 -53 -198 -11 -179 78 2 12 20 76 40 142 19 66 50 175 67 243 32 118 32 123 15 142 -22 25 -37 25 -57 3z' },
        { type: 'path', d: 'M2815 2118 c-98 -74 -214 -110 -355 -110 -83 -1 -136 12 -258 63 -38 16 -65 5 -70 -30 -5 -29 10 -45 66 -71 126 -60 303 -78 436 -44 122 30 286 132 286 177 0 21 -27 47 -48 46 -9 0 -35 -14 -57 -31z' },
        { type: 'path', d: 'M2117 1573 c-28 -27 20 -122 95 -188 176 -154 444 -166 650 -28 72 47 138 116 138 143 0 19 -30 50 -48 50 -6 0 -37 -26 -70 -57 -106 -105 -201 -139 -361 -131 -76 4 -109 10 -153 30 -67 31 -130 86 -165 145 -20 34 -31 43 -52 43 -15 0 -31 -3 -34 -7z' },
        { type: 'path', d: 'M2525 528 c-40 -22 -65 -52 -76 -90 -8 -32 -6 -46 10 -82 23 -52 61 -76 122 -76 35 0 48 6 80 39 33 33 39 45 39 82 0 55 -27 101 -73 122 -40 20 -73 21 -102 5z' },
    ],
};
export const johanSadIcon = {
    viewBox: '0 0 600 525',
    defaultSize: 24,
    fill: 'currentColor',
    elements: [
        { type: 'path', d: 'M3205,5060C3098,5038 2993,4984 2914,4908L2873,4868L2819,4909C2789,4932 2731,4965 2690,4982C2617,5014 2610,5015 2475,5015C2320,5015 2264,5002 2127,4933C2016,4878 1895,4741 1855,4623C1843,4587 1842,4586 1754,4569C1593,4536 1468,4456 1387,4332C1288,4182 1250,4011 1281,3859L1292,3804L1218,3730C1138,3649 1121,3622 1084,3516C1037,3382 1061,3192 1135,3094L1161,3060L1119,3008C1067,2942 1027,2857 1006,2763C986,2674 986,2639 1005,2542C1033,2405 1105,2287 1208,2210L1241,2185L1226,2125C1217,2093 1210,2030 1210,1987C1210,1836 1262,1708 1365,1605C1436,1534 1521,1487 1626,1460C1714,1437 1763,1435 1843,1451L1900,1463L1960,1399C2029,1325 2034,1300 1999,1197C1958,1073 1893,975 1761,834C1575,635 1605,539 1890,425C2041,365 2172,361 2251,416C2330,470 2384,635 2378,800C2373,910 2365,929 2285,1020C2228,1083 2191,1148 2190,1183C2190,1198 2201,1194 2263,1161C2564,998 2932,1021 3281,1226C3503,1356 3715,1582 3793,1773C3802,1793 3813,1810 3817,1810C3821,1810 3835,1794 3847,1775C3868,1743 3869,1739 3855,1699C3835,1644 3768,1523 3730,1474C3625,1341 3418,1168 3213,1041C3088,964 3012,897 2957,812C2888,707 2866,646 2865,565C2865,452 2913,394 3028,369C3137,346 3429,380 3685,446C3881,496 4169,606 4313,684C4336,696 4396,728 4445,755C4612,844 4680,903 4700,975C4728,1074 4690,1136 4539,1240C4394,1338 4299,1413 4252,1464C4228,1490 4210,1513 4212,1516C4215,1518 4243,1511 4276,1500C4560,1401 4909,1525 5039,1769C5096,1878 5120,2017 5100,2120C5076,2238 5076,2237 5103,2255C5138,2278 5207,2371 5235,2433C5262,2492 5290,2619 5290,2680C5290,2831 5203,3025 5094,3118L5057,3150L5088,3212C5238,3511 5100,3881 4799,3990L4765,4002L4765,4124C4765,4259 4754,4303 4691,4425C4649,4507 4543,4617 4457,4669C4332,4743 4162,4779 4030,4760C3942,4747 3947,4746 3926,4783C3916,4800 3873,4849 3831,4890C3701,5017 3558,5071 3356,5069C3295,5068 3227,5064 3205,5060ZM3000,4134C3212,4068 3370,3948 3487,3767C3631,3546 3669,3326 3690,2615C3700,2265 3711,2132 3737,2035C3760,1951 3757,1920 3714,1827C3561,1498 3230,1237 2869,1164C2769,1144 2569,1149 2475,1175C2259,1233 2027,1419 1906,1629C1761,1883 1737,2152 1816,2634C1830,2717 1846,2846 1852,2920C1861,3044 1806.992,3073.522 1830.992,3099.522C1902.992,3176.522 1669,3092 1765,3045C1822,3017 1842.667,3114.667 1830,3154C1817.333,3193.333 1814,3170 1679,3141C1650,3135 1882.917,2972.938 1852.917,2955.938L1857,3187L1863,3306C1879,3623 2032,3891 2290,4049C2435,4138 2573,4171 2775,4165C2891,4162 2929,4157 3000,4134Z' },
        { type: 'group', transform: 'matrix(-0.955999,0.293371,-0.293371,-0.955999,6806.515088,5329.826422)', elements: [
                { type: 'path', d: 'M2863,3275C2757,3246 2700,3205 2700,3161C2700,3111 2730,3106 2810,3144C2868,3172 2884,3175 2970,3175C3075,3175 3114,3161 3198,3092C3235,3061 3245,3058 3268,3066C3338,3091 3276,3181 3144,3246C3085,3276 3059,3282 2994,3286C2943,3289 2897,3285 2863,3275Z' },
            ] },
        { type: 'group', transform: 'matrix(-0.809238,-0.587481,0.587481,-0.809238,2550.089841,7475.206453)', elements: [
                { type: 'path', d: 'M2863,3275C2757,3246 2700,3205 2700,3161C2700,3111 2730,3106 2810,3144C2868,3172 2884,3175 2970,3175C3075,3175 3114,3161 3198,3092C3235,3061 3245,3058 3268,3066C3338,3091 3276,3181 3144,3246C3085,3276 3059,3282 2994,3286C2943,3289 2897,3285 2863,3275Z' },
            ] },
        { type: 'path', d: 'M2060,3009C1963,2970 1945,2839 2029,2783C2148,2702 2287,2852 2198,2966C2177,2992 2123,3021 2098,3019C2091,3019 2074,3014 2060,3009Z' },
        { type: 'path', d: 'M2924,3006C2829,2964 2816,2833 2902,2780C3024,2706 3156,2853 3068,2965C3047,2992 2994,3020 2968,3020C2961,3019 2941,3013 2924,3006Z' },
        { type: 'path', d: 'M2338,2943C2330,2933 2320,2916 2317,2905C2314,2894 2296,2829 2277,2760C2258,2691 2226,2579 2206,2511C2177,2411 2172,2381 2179,2354C2213,2232 2350,2184 2479,2250C2511,2266 2560,2284 2586,2291C2613,2298 2641,2307 2648,2313C2665,2327 2663,2354 2642,2373C2626,2388 2618,2388 2562,2375C2527,2367 2478,2349 2452,2335C2352,2282 2254,2324 2273,2413C2275,2425 2293,2489 2313,2555C2332,2621 2363,2730 2380,2798C2412,2916 2412,2921 2395,2940C2373,2965 2358,2965 2338,2943Z' },
        { type: 'group', transform: 'matrix(-0.995334,0.096488,-0.096488,-0.995334,5235.089521,3674.83587)', elements: [
                { type: 'path', d: 'M2815,2118C2717,2044 2601,2008 2460,2008C2377,2007 2324,2020 2202,2071C2164,2087 2137,2076 2132,2041C2127,2012 2142,1996 2198,1970C2324,1910 2501,1892 2634,1926C2756,1956 2920,2058 2920,2103C2920,2124 2893,2150 2872,2149C2863,2149 2837,2135 2815,2118Z' },
            ] },
        { type: 'path', d: 'M2117,1573C2089,1546 2137,1451 2212,1385C2388,1231 2656,1219 2862,1357C2934,1404 3000,1473 3000,1500C3000,1519 2970,1550 2952,1550C2946,1550 2915,1524 2882,1493C2776,1388 2681,1354 2521,1362C2445,1366 2412,1372 2368,1392C2301,1423 2238,1478 2203,1537C2183,1571 2172,1580 2151,1580C2136,1580 2120,1577 2117,1573Z' },
        { type: 'path', d: 'M2525,528C2485,506 2460,476 2449,438C2441,406 2443,392 2459,356C2482,304 2520,280 2581,280C2616,280 2629,286 2661,319C2694,352 2700,364 2700,401C2700,456 2673,502 2627,523C2587,543 2554,544 2525,528Z' },
    ],
};
/**
 * Johan Thinking icons (two frames for animation).
 * These use a different root transform than the standard Johan icons:
 * matrix(0.1,0,0,-0.1,28,525) — note the 28px x-offset.
 * The icon component must apply this as the root <G> transform.
 */
export const johanThinking1Icon = {
    viewBox: '0 0 600 525',
    defaultSize: 24,
    fill: 'currentColor',
    elements: [
        { type: 'group', transform: 'matrix(-1,0,0,1,5719,0)', elements: [
                { type: 'path', d: 'M2454,5051C2338,5020 2246,4967 2165,4887C2125,4847 2085,4800 2075,4782L2059,4748L1997,4757C1911,4768 1800,4764 1727,4745C1549,4701 1379,4566 1300,4410C1246,4301 1235,4254 1235,4125L1235,4005L1160,3970C882,3840 769,3496 912,3212L943,3150L901,3114C854,3073 789,2982 761,2917C735,2856 710,2740 710,2678C710,2611 741,2487 776,2414C790,2384 829,2329 863,2294L923,2229L909,2172C888,2088 893,1959 919,1873C1006,1584 1354,1408 1675,1490C1718,1501 1759,1515 1767,1521C1785,1537 1794,1526 1782,1503C1762,1466 1595,1332 1441,1230C1301,1138 1262,1055 1309,956C1337,899 1377,864 1494,796C1865,577 2284,429 2660,385C2906,356 3027,369 3087,432C3153,501 3154,604 3090,735C3023,872 2946,951 2775,1055C2479,1235 2284,1424 2183,1626L2127,1739L2154,1780C2168,1802 2182,1820 2184,1820C2186,1820 2202,1791 2218,1756C2388,1393 2842,1083 3233,1063C3339,1057 3340,1057 3346,1031C3348,1017 3355,990 3361,972C3369,947 3368,930 3355,895C3334,842 3341,794 3376,734C3420,657 3527,590 3606,590C3645,590 3647,589 3664,541C3710,412 3828,356 3979,391C4032,403 4041,396 4085,312C4109,267 4120,255 4139,255C4185,255 4188,284 4151,356C4113,430 4081,458 3995,492C3887,536 3846,568 3720,706C3677,753 3655,769 3618,779C3561,795 3540,789 3540,756C3540,739 3547,729 3563,725C3614,711 3640,697 3640,684C3640,643 3545,670 3477,729C3418,781 3404,863 3446,905C3460,918 3482,921 3559,920C3612,919 3660,919 3666,919C3684,920 3691,949 3679,971C3670,989 3659,991 3553,989C3431,988 3420,991 3420,1037C3420,1049 3430,1071 3443,1086C3471,1118 3529,1126 3640,1112C3722,1102 3750,1109 3750,1140C3750,1171 3716,1181 3584,1187L3460,1193L3460,1222C3460,1255 3488,1287 3526,1296C3541,1300 3603,1299 3664,1295C3850,1283 3845,1282 3848,1306C3853,1338 3828,1351 3745,1361C3704,1366 3629,1384 3579,1400C3530,1416 3447,1435 3397,1440C3146,1469 3156,1467 3133,1495C3105,1527 3105,1532 3129,1561C3145,1581 3159,1585 3231,1590C3352,1597 3522,1584 3615,1560C3712,1535 3893,1468 3975,1427C4008,1411 4068,1375 4108,1348C4189,1293 4223,1288 4228,1331C4230,1352 4222,1362 4180,1391L4128,1425L4133,1530C4136,1592 4145,1655 4155,1683C4177,1745 4229,1800 4264,1800C4302,1800 4311,1768 4298,1679C4275,1518 4303,1367 4398,1138C4431,1059 4470,961 4485,920C4499,879 4535,798 4563,740C4612,642 4617,635 4645,635C4665,635 4676,640 4678,653C4680,662 4659,719 4631,779C4603,839 4567,924 4551,967C4535,1010 4497,1106 4465,1180C4408,1315 4374,1431 4384,1456C4387,1464 4396,1470 4404,1470C4435,1470 4578,1552 4624,1596C4764,1731 4825,1950 4773,2133C4757,2190 4757,2193 4776,2203C4786,2208 4823,2241 4858,2276C4932,2351 4971,2428 4994,2542C5014,2639 5014,2674 4994,2763C4973,2856 4939,2931 4890,2997C4868,3026 4850,3052 4850,3055C4850,3058 4869,3100 4892,3148C4932,3229 4935,3242 4938,3335C4941,3417 4938,3448 4920,3507C4892,3598 4840,3680 4765,3748L4707,3801L4719,3857C4750,4012 4712,4181 4613,4333C4533,4454 4399,4540 4243,4570L4159,4586L4136,4640C4047,4859 3835,5002 3573,5017C3412,5026 3296,4994 3182,4909L3129,4868L3082,4912C3024,4966 2958,5006 2871,5038C2778,5073 2560,5080 2454,5051ZM3445,4151C3570,4125 3633,4099 3737,4031C3970,3877 4116,3623 4137,3338C4140,3289 4141,3250 4139,3250C4137,3250 4113,3257 4086,3265C4013,3287 3966,3273 3841,3192C3778,3151 3745,3136 3706,3131C3659,3126 3655,3123 3652,3097C3642,3010 3753,3023 3902,3125C3990,3186 4058,3193 4114,3149C4137,3131 4140,3122 4140,3062C4141,2961 4157,2816 4192,2595C4218,2428 4224,2366 4224,2215C4225,2100 4220,2006 4211,1956C4199,1888 4191,1872 4153,1826C4102,1767 4085,1731 4064,1640C4044,1553 4042,1549 4021,1523L4002,1500L3935,1530C3728,1623 3518,1670 3311,1670C3162,1670 3118,1660 3073,1615C3044,1586 3040,1575 3040,1531C3040,1489 3045,1475 3071,1445C3110,1401 3165,1385 3324,1371C3389,1365 3445,1358 3448,1356C3450,1353 3439,1335 3422,1316C3388,1277 3375,1234 3385,1190C3391,1164 3388,1160 3365,1154C3299,1138 3112,1166 2975,1212C2684,1312 2392,1577 2280,1846C2241,1939 2241,1946 2268,2070C2293,2186 2310,2387 2310,2569C2310,2758 2327,3080 2345,3235C2372,3469 2421,3625 2510,3764C2652,3984 2866,4122 3130,4163C3202,4175 3362,4168 3445,4151Z' },
            ] },
        { type: 'group', transform: 'matrix(-1,0,0,1,5719,0)', elements: [
                { type: 'path', d: 'M2804,3266C2744,3247 2652,3192 2633,3164C2620,3144 2619,3134 2628,3115C2644,3081 2671,3083 2727,3124C2829,3196 2908,3197 3046,3131C3212,3051 3299,3032 3348,3066C3372,3083 3378,3124 3358,3137C3351,3141 3320,3145 3290,3145C3244,3145 3217,3153 3135,3194C2956,3281 2894,3294 2804,3266Z' },
            ] },
        { type: 'group', transform: 'matrix(1,0,0,1,-280,0)', elements: [
                { type: 'path', d: 'M2338,2943C2330,2933 2320,2916 2317,2905C2314,2894 2296,2829 2277,2760C2258,2691 2226,2579 2206,2511C2177,2411 2172,2381 2179,2354C2213,2232 2350,2184 2479,2250C2511,2266 2560,2284 2586,2291C2613,2298 2641,2307 2648,2313C2665,2327 2663,2354 2642,2373C2626,2388 2618,2388 2562,2375C2527,2367 2478,2349 2452,2335C2352,2282 2254,2324 2273,2413C2275,2425 2293,2489 2313,2555C2332,2621 2363,2730 2380,2798C2412,2916 2412,2921 2395,2940C2373,2965 2358,2965 2338,2943Z' },
            ] },
        { type: 'group', transform: 'matrix(1,0,0,1,-310,0)', elements: [
                { type: 'path', d: 'M2060,3009C1963,2970 1945,2839 2029,2783C2148,2702 2287,2852 2198,2966C2177,2992 2123,3021 2098,3019C2091,3019 2074,3014 2060,3009Z' },
            ] },
        { type: 'group', transform: 'matrix(1,0,0,1,-310,0)', elements: [
                { type: 'path', d: 'M2924,3006C2829,2964 2816,2833 2902,2780C3024,2706 3156,2853 3068,2965C3047,2992 2994,3020 2968,3020C2961,3019 2941,3013 2924,3006Z' },
            ] },
        { type: 'group', transform: 'matrix(-1,0,0,1,5719,0)', elements: [
                { type: 'path', d: 'M3360,2037C3291,2019 3222,1997 3205,1989C3172,1973 3162,1947 3181,1924C3195,1906 3202,1907 3335,1944C3432,1971 3505,1976 3560,1960C3585,1952 3613,1953 3657,1961C3710,1972 3724,1971 3764,1956C3824,1933 3855,1937 3855,1970C3855,1998 3809,2034 3748,2052C3718,2061 3698,2060 3654,2050C3605,2038 3593,2039 3552,2053C3526,2063 3501,2070 3495,2070C3490,2069 3429,2055 3360,2037Z' },
            ] },
        { type: 'group', transform: 'matrix(-1,0,0,1,5719,0)', elements: [
                { type: 'path', d: 'M3346,508C3256,429 3306,289 3426,286C3523,284 3583,388 3536,478C3516,517 3473,540 3422,540C3393,540 3374,532 3346,508Z' },
            ] },
        { type: 'group', transform: 'matrix(-1,0,0,1,5719,0)', elements: [
                { type: 'path', d: 'M1497,3C2324,1 3676,1 4502,3C5329,4 4653,5 3000,5C1347,5 671,4 1497,3Z' },
            ] },
    ],
};
export const johanThinking2Icon = {
    viewBox: '0 0 600 525',
    defaultSize: 24,
    fill: 'currentColor',
    elements: [
        { type: 'group', transform: 'matrix(-1,0,0,1,5719,0)', elements: [
                { type: 'path', d: 'M2454,5051C2338,5020 2246,4967 2165,4887C2125,4847 2085,4800 2075,4782L2059,4748L1997,4757C1911,4768 1800,4764 1727,4745C1549,4701 1379,4566 1300,4410C1246,4301 1235,4254 1235,4125L1235,4005L1160,3970C882,3840 769,3496 912,3212L943,3150L901,3114C854,3073 789,2982 761,2917C735,2856 710,2740 710,2678C710,2611 741,2487 776,2414C790,2384 829,2329 863,2294L923,2229L909,2172C888,2088 893,1959 919,1873C1006,1584 1354,1408 1675,1490C1718,1501 1759,1515 1767,1521C1785,1537 1794,1526 1782,1503C1762,1466 1595,1332 1441,1230C1301,1138 1262,1055 1309,956C1337,899 1377,864 1494,796C1865,577 2284,429 2660,385C2906,356 3027,369 3087,432C3153,501 3154,604 3090,735C3023,872 2946,951 2775,1055C2479,1235 2284,1424 2183,1626L2127,1739L2154,1780C2168,1802 2182,1820 2184,1820C2186,1820 2202,1791 2218,1756C2388,1393 2842,1083 3233,1063C3339,1057 3340,1057 3346,1031C3348,1017 3355,990 3361,972C3369,947 3368,930 3355,895C3334,842 3341,794 3376,734C3420,657 3527,590 3606,590C3645,590 3647,589 3664,541C3710,412 3828,356 3979,391C4032,403 4041,396 4085,312C4109,267 4120,255 4139,255C4185,255 4188,284 4151,356C4113,430 4081,458 3995,492C3887,536 3846,568 3720,706C3677,753 3655,769 3618,779C3561,795 3540,789 3540,756C3540,739 3547,729 3563,725C3614,711 3640,697 3640,684C3640,643 3545,670 3477,729C3418,781 3404,863 3446,905C3460,918 3482,921 3559,920C3612,919 3660,919 3666,919C3684,920 3691,949 3679,971C3670,989 3659,991 3553,989C3431,988 3420,991 3420,1037C3420,1049 3430,1071 3443,1086C3471,1118 3529,1126 3640,1112C3722,1102 3750,1109 3750,1140C3750,1171 3716,1181 3584,1187L3460,1193L3460,1222C3460,1255 3488,1287 3526,1296C3541,1300 3603,1299 3664,1295C3850,1283 3845,1282 3848,1306C3853,1338 3828,1351 3745,1361C3704,1366 3629,1384 3579,1400C3530,1416 3425.324,1446.352 3377,1470C3236,1539 3166,1557 3143,1585C3115,1617 3125,1662 3149,1691C3165,1711 3209.004,1692.95 3241,1680C3372.255,1626.876 3469.934,1597.388 3615,1560C3712,1535 3893,1468 3975,1427C4008,1411 4068,1375 4108,1348C4189,1293 4223,1288 4228,1331C4230,1352 4222,1362 4180,1391L4128,1425L4133,1530C4136,1592 4145,1655 4155,1683C4177,1745 4229,1800 4264,1800C4302,1800 4311,1768 4298,1679C4275,1518 4303,1367 4398,1138C4431,1059 4470,961 4485,920C4499,879 4535,798 4563,740C4612,642 4617,635 4645,635C4665,635 4676,640 4678,653C4680,662 4659,719 4631,779C4603,839 4567,924 4551,967C4535,1010 4497,1106 4465,1180C4408,1315 4374,1431 4384,1456C4387,1464 4396,1470 4404,1470C4435,1470 4578,1552 4624,1596C4764,1731 4825,1950 4773,2133C4757,2190 4757,2193 4776,2203C4786,2208 4823,2241 4858,2276C4932,2351 4971,2428 4994,2542C5014,2639 5014,2674 4994,2763C4973,2856 4939,2931 4890,2997C4868,3026 4850,3052 4850,3055C4850,3058 4869,3100 4892,3148C4932,3229 4935,3242 4938,3335C4941,3417 4938,3448 4920,3507C4892,3598 4840,3680 4765,3748L4707,3801L4719,3857C4750,4012 4712,4181 4613,4333C4533,4454 4399,4540 4243,4570L4159,4586L4136,4640C4047,4859 3835,5002 3573,5017C3412,5026 3296,4994 3182,4909L3129,4868L3082,4912C3024,4966 2958,5006 2871,5038C2778,5073 2560,5080 2454,5051ZM3445,4151C3570,4125 3633,4099 3737,4031C3970,3877 4116,3623 4137,3338C4140,3289 4141,3250 4139,3250C4137,3250 4113,3257 4086,3265C4013,3287 3966,3273 3841,3192C3778,3151 3745,3136 3706,3131C3659,3126 3655,3123 3652,3097C3642,3010 3753,3023 3902,3125C3990,3186 4058,3193 4114,3149C4137,3131 4140,3122 4140,3062C4141,2961 4157,2816 4192,2595C4218,2428 4224,2366 4224,2215C4225,2100 4220,2006 4211,1956C4199,1888 4191,1872 4153,1826C4102,1767 4085,1731 4064,1640C4044,1553 4042,1549 4021,1523L4002,1500L3935,1530C3728,1623 3548,1660 3351,1740C3212.949,1796.061 3128,1780 3083,1735C3054,1706 3050,1665 3050,1621C3050,1579 3055,1565 3081,1535C3120,1491 3175,1485 3324,1411C3386.287,1380.065 3445,1358 3448,1356C3450,1353 3439,1335 3422,1316C3388,1277 3375,1234 3385,1190C3391,1164 3388,1160 3365,1154C3299,1138 3112,1166 2975,1212C2684,1312 2392,1577 2280,1846C2241,1939 2241,1946 2268,2070C2293,2186 2310,2387 2310,2569C2310,2758 2327,3080 2345,3235C2372,3469 2421,3625 2510,3764C2652,3984 2866,4122 3130,4163C3202,4175 3362,4168 3445,4151Z' },
            ] },
        { type: 'group', transform: 'matrix(-1,0,0,1,5719,0)', elements: [
                { type: 'path', d: 'M2804,3266C2744,3247 2652,3192 2633,3164C2620,3144 2619,3134 2628,3115C2644,3081 2671,3083 2727,3124C2829,3196 2908,3197 3046,3131C3212,3051 3299,3032 3348,3066C3372,3083 3378,3124 3358,3137C3351,3141 3320,3145 3290,3145C3244,3145 3217,3153 3135,3194C2956,3281 2894,3294 2804,3266Z' },
            ] },
        { type: 'group', transform: 'matrix(1,0,0,1,-280,0)', elements: [
                { type: 'path', d: 'M2338,2943C2330,2933 2320,2916 2317,2905C2314,2894 2296,2829 2277,2760C2258,2691 2226,2579 2206,2511C2177,2411 2172,2381 2179,2354C2213,2232 2350,2184 2479,2250C2511,2266 2560,2284 2586,2291C2613,2298 2641,2307 2648,2313C2665,2327 2663,2354 2642,2373C2626,2388 2618,2388 2562,2375C2527,2367 2478,2349 2452,2335C2352,2282 2254,2324 2273,2413C2275,2425 2293,2489 2313,2555C2332,2621 2363,2730 2380,2798C2412,2916 2412,2921 2395,2940C2373,2965 2358,2965 2338,2943Z' },
            ] },
        { type: 'group', transform: 'matrix(1,0,0,1,-310,0)', elements: [
                { type: 'path', d: 'M2060,3009C1963,2970 1945,2839 2029,2783C2148,2702 2287,2852 2198,2966C2177,2992 2123,3021 2098,3019C2091,3019 2074,3014 2060,3009Z' },
            ] },
        { type: 'group', transform: 'matrix(1,0,0,1,-310,0)', elements: [
                { type: 'path', d: 'M2924,3006C2829,2964 2816,2833 2902,2780C3024,2706 3156,2853 3068,2965C3047,2992 2994,3020 2968,3020C2961,3019 2941,3013 2924,3006Z' },
            ] },
        { type: 'group', transform: 'matrix(-1,0,0,1,5719,0)', elements: [
                { type: 'path', d: 'M3360,2037C3291,2019 3222,1997 3205,1989C3172,1973 3162,1947 3181,1924C3195,1906 3202,1907 3335,1944C3432,1971 3505,1976 3560,1960C3585,1952 3613,1953 3657,1961C3710,1972 3724,1971 3764,1956C3824,1933 3855,1937 3855,1970C3855,1998 3809,2034 3748,2052C3718,2061 3698,2060 3654,2050C3605,2038 3593,2039 3552,2053C3526,2063 3501,2070 3495,2070C3490,2069 3429,2055 3360,2037Z' },
            ] },
        { type: 'group', transform: 'matrix(-1,0,0,1,5719,0)', elements: [
                { type: 'path', d: 'M3346,508C3256,429 3306,289 3426,286C3523,284 3583,388 3536,478C3516,517 3473,540 3422,540C3393,540 3374,532 3346,508Z' },
            ] },
        { type: 'group', transform: 'matrix(-1,0,0,1,5719,0)', elements: [
                { type: 'path', d: 'M1497,3C2324,1 3676,1 4502,3C5329,4 4653,5 3000,5C1347,5 671,4 1497,3Z' },
            ] },
    ],
};
/**
 * Johan Sebastian toggle icon — used as the mini icon inside the settings menu toggle.
 * Source: johan-minimal.svg. Uses matrix(0.1,0,0,-0.1,0,525) Y-flip group transform.
 */
export const johanToggleIcon = {
    viewBox: '0 0 600 525',
    defaultSize: 12,
    fill: 'currentColor',
    elements: [
        { type: 'group', transform: 'matrix(0.1,0,0,-0.1,0,525)', elements: [
                { type: 'path', d: 'M3737,2035C3760,1951 3793,1870 3797,1870C3801,1870 3835,1794 3847,1775C3868,1743 3869,1739 3855,1699C3835,1644 3768,1523 3730,1474C3625,1341 3418,1168 3213,1041C3088,964 3012,897 2957,812C2888,707 2866,646 2865,565C2865,452 2913,394 3028,369C3137,346 3429,380 3685,446C3881,496 4169,606 4313,684C4336,696 4396,728 4445,755C4612,844 4680,903 4700,975C4728,1074 4690,1136 4539,1240C4394,1338 4299,1413 4252,1464C4228,1490 4210,1513 4212,1516C4215,1518 4243,1511 4276,1500C4560,1401 4909,1525 5039,1769C5096,1878 5120,2017 5100,2120C5076,2238 5076,2237 5103,2255C5138,2278 5207,2371 5235,2433C5262,2492 5290,2619 5290,2680C5290,2831 5203,3025 5094,3118L5057,3150L5088,3212C5238,3511 5100,3881 4799,3990L4765,4002L4765,4124C4765,4259 4754,4303 4691,4425C4649,4507 4543,4617 4457,4669C4332,4743 4162,4779 4030,4760C3942,4747 3947,4746 3926,4783C3916,4800 3873,4849 3831,4890C3701,5017 3558,5071 3356,5069C3295,5068 3227,5064 3205,5060C3098,5038 2993,4984 2914,4908L2873,4868L2819,4909C2789,4932 2731,4965 2690,4982C2617,5014 2610,5015 2475,5015C2320,5015 2264,5002 2127,4933C2016,4878 1895,4741 1855,4623C1843,4587 1842,4586 1754,4569C1593,4536 1468,4456 1387,4332C1288,4182 1250,4011 1281,3859L1292,3804L1218,3730C1138,3649 1121,3622 1084,3516C1037,3382 1061,3192 1135,3094L1161,3060L1119,3008C1067,2942 1027,2857 1006,2763C986,2674 986,2639 1005,2542C1033,2405 1105,2287 1208,2210L1241,2185L1226,2125C1217,2093 1210,2030 1210,1987C1210,1836 1262,1708 1365,1605C1436,1534 1521,1487 1626,1460C1714,1437 1763,1435 1843,1451L1900,1463L1960,1399C2029,1325 2034,1300 1999,1197C1958,1073 1893,975 1761,834C1575,635 1605,539 1890,425C2041,365 2172,361 2251,416C2330,470 2384,635 2378,800C2373,910 2365,929 2285,1020C2228,1083 2191,1148 2190,1183C2190,1198 2201,1194 2263,1161C2509.839,1027.33 2801.737,1018.745 3091.263,1133.041C3226.939,1186.601 3184.894,1276.936 3093.687,1234.869C3021.094,1203.522 2945.725,1179.515 2869,1164C2769,1144 2569,1149 2475,1175C2259,1233 2027,1419 1906,1629C1761,1883 1737,2152 1816,2634C1830,2717 1846,2846 1852,2920C1852.942,2932.98 1853.194,2944.924 1852.917,2955.938C1852.799,2960.63 1852.585,2965.153 1852.288,2969.515C1842.617,2985.548 1813.01,3012.425 1780.784,3040.208C1775.873,3040.704 1770.613,3042.243 1765,3045C1747.239,3053.696 1740.773,3063.676 1741.575,3073.68C1700.51,3108.724 1666.88,3138.492 1679,3141C1814,3170 1817.333,3193.333 1830,3154C1832.091,3147.507 1833.274,3139.423 1833.534,3130.578C1847.335,3129.948 1851.117,3121.045 1830.992,3099.522C1829.633,3092.328 1827.739,3085.222 1825.304,3078.562C1828.735,3058.458 1848.24,3028.888 1852.288,2969.515C1852.588,2969.017 1852.869,2968.529 1853.131,2968.052L1857,3187L1863,3306C1879,3623 2032,3891 2290,4049C2435,4138 2573,4171 2775,4165C2891,4162 2929,4157 3000,4134C3212,4068 3370,3948 3487,3767C3631,3546 3669,3326 3690,2615C3700,2265 3711,2132 3737,2035Z' },
                { type: 'path', d: 'M1825.304,3078.562C1827.739,3085.222 1829.633,3092.328 1830.992,3099.522C1825.141,3093.184 1823.926,3086.636 1825.304,3078.562Z' },
                { type: 'path', d: 'M1780.784,3040.208C1802.174,3038.048 1816.935,3055.672 1825.304,3078.562C1823.926,3086.636 1825.141,3093.184 1830.992,3099.522C1832.982,3110.059 1833.823,3120.786 1833.534,3130.578C1807.098,3131.785 1743.897,3102.633 1741.575,3073.68C1754.311,3062.812 1767.761,3051.436 1780.784,3040.208Z' },
                { type: 'path', d: 'M1853.131,2968.052C1856.325,2962.226 1856.569,2958.007 1852.917,2955.938L1853.131,2968.052Z' },
                { type: 'path', d: 'M1830.992,3099.522C1851.117,3121.045 1847.335,3129.948 1833.534,3130.578C1833.823,3120.786 1832.982,3110.059 1830.992,3099.522Z' },
                { type: 'path', d: 'M1741.575,3073.68C1740.773,3063.676 1747.239,3053.696 1765,3045C1770.613,3042.243 1775.873,3040.704 1780.784,3040.208C1767.761,3051.436 1754.311,3062.812 1741.575,3073.68Z' },
                { type: 'path', d: 'M1833.534,3130.578C1833.274,3139.423 1832.091,3147.507 1830,3154C1817.333,3193.333 1814,3170 1679,3141C1666.88,3138.492 1700.51,3108.724 1741.575,3073.68C1743.897,3102.633 1807.098,3131.785 1833.534,3130.578Z' },
                { type: 'path', d: 'M1780.784,3040.208C1813.01,3012.425 1842.617,2985.548 1852.288,2969.515C1848.24,3028.888 1828.735,3058.458 1825.304,3078.562C1816.935,3055.672 1802.174,3038.048 1780.784,3040.208Z' },
            ] },
    ],
};
export const clockIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 16,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'circle', cx: 12, cy: 12, r: 9 },
        { type: 'polyline', points: '12 7 12 12 16 14' },
    ],
};
/** Two looping arrows: a section's repeat count ("×2"). */
export const repeatIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 16,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M17 2l4 4-4 4' },
        { type: 'path', d: 'M3 11v-1a4 4 0 0 1 4-4h14' },
        { type: 'path', d: 'M7 22l-4-4 4-4' },
        { type: 'path', d: 'M21 13v1a4 4 0 0 1-4 4H3' },
    ],
};
/** Sticky note with a folded corner: a section's free-text note. */
export const noteIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 16,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    elements: [
        { type: 'path', d: 'M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z' },
        { type: 'path', d: 'M15 3v4a2 2 0 0 0 2 2h4' },
    ],
};
/**
 * Crossed-out eighth note: a slot with no chord, which plays silent. Not a
 * notation rest on purpose, so it carries no duration (slots can be bars or
 * subdivisions) and can't be mistaken for rhythm notation. Filled shapes
 * only, no stroke.
 */
export const silenceIcon = {
    viewBox: '0 0 24 24',
    defaultSize: 24,
    fill: 'currentColor',
    elements: [
        // Note head, stem, flag
        { type: 'path', d: 'M6.8 18.83A3.3 2.4 -20 1 0 13 16.57A3.3 2.4 -20 1 0 6.8 18.83Z' },
        { type: 'path', d: 'M11.8 16.9V3.7h1.5v13.2Z' },
        { type: 'path', d: 'M13.3 3.7C13.5 6.7 18.5 7.5 17.5 13.1C17.3 13.9 16.7 13.8 16.9 13C17.5 9.7 14.8 8.9 13.3 8.3Z' },
        // Strike through the whole note
        { type: 'path', d: 'M3.3 4.4L4.4 3.3L20.7 19.6L19.6 20.7Z' },
    ],
};
export const eyeIcon = {
    viewBox: '0 0 16 16',
    defaultSize: 24,
    fill: 'currentColor',
    elements: [
        { type: 'path', d: 'M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z' },
        { type: 'path', d: 'M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z' },
    ],
};
export const gearIcon = {
    viewBox: '0 0 16 16',
    defaultSize: 24,
    fill: 'currentColor',
    elements: [
        { type: 'path', d: 'M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z' },
    ],
};
// ---------------------------------------------------------------------------
// All icons map (useful for iteration / lookup by name)
// ---------------------------------------------------------------------------
export const allIcons = {
    beats: beatsIcon,
    beatsToggle: beatsToggleIcon,
    chevronLeft: chevronLeftIcon,
    clipboard: clipboardIcon,
    clock: clockIcon,
    repeat: repeatIcon,
    note: noteIcon,
    silence: silenceIcon,
    cloud: cloudIcon,
    close: closeIcon,
    degrees: degreesIcon,
    download: downloadIcon,
    duplicate: duplicateIcon,
    edit: editIcon,
    eye: eyeIcon,
    feedback: feedbackIcon,
    gear: gearIcon,
    guitar: guitarIcon,
    help: helpIcon,
    info: infoIcon,
    insertAfter: insertAfterIcon,
    insertBefore: insertBeforeIcon,
    language: languageIcon,
    loadSongs: loadSongsIcon,
    lyrics: lyricsIcon,
    lyricsToggle: lyricsToggleIcon,
    perform: performIcon,
    play: playIcon,
    pause: pauseIcon,
    menu: menuIcon,
    dragHandle: dragHandleIcon,
    reorder: reorderIcon,
    minus: minusIcon,
    moreOptions: moreOptionsIcon,
    musicKey: musicKeyIcon,
    musicNote: musicNoteIcon,
    newSong: newSongIcon,
    pdf: pdfIcon,
    pencil: pencilIcon,
    piano: pianoIcon,
    plus: plusIcon,
    freePlan: freePlanIcon,
    proPlan: proPlanIcon,
    prohibited: prohibitedIcon,
    redo: redoIcon,
    return: returnIcon,
    saving: savingIcon,
    search: searchIcon,
    share: shareIcon,
    speaker: speakerIcon,
    speakerOff: speakerOffIcon,
    skipToStart: skipToStartIcon,
    themeToggleMoon: themeToggleMoonIcon,
    themeToggleSun: themeToggleSunIcon,
    trash: trashIcon,
    undo: undoIcon,
    upload: uploadIcon,
    buffetLogo: buffetLogoIcon,
    johan: johanIcon,
    johanSad: johanSadIcon,
    johanThinking1: johanThinking1Icon,
    johanThinking2: johanThinking2Icon,
    johanToggle: johanToggleIcon,
};
